/* global YT */

/**
 * @param {node selector} videoBannerSelector example {div.video-banner--js.main-banner__background-video}
 * @param {string} videoId example MmzadGwyYjY
 */
const appendVideoBanner = (videoBannerSelector, videoId) => {
    const width = videoBannerSelector.offsetWidth,
        height = Math.round(width / 1.7777),
        videoSice = { width, height };

    /^[0-9]+$/.test(videoId)
        ? appendVimeoBanner(videoBannerSelector, videoId, videoSice)
        : appendYoutubeBanner(videoBannerSelector, videoId, videoSice);

    /**
     *
     * @param {node selector} videoBannerSelector example {div.video-banner--js.main-banner__background-video}
     * @param {string} videoId example MmzadGwyYjY
     * @param {obj} videoSice {width, height}
     */
    function appendYoutubeBanner(videoBannerSelector, videoId, videoSice) {
        const newSelector =
            videoBannerSelector.querySelector(".lightbox__iframe");

        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        let player;
        window.onYouTubeIframeAPIReady = function () {
            player = new YT.Player(newSelector, {
                videoId: videoId,
                host: 'https://www.youtube-nocookie.com',
                height: videoSice.height,
                width: videoSice.width,
                playerVars: {
                    autoplay: 1,
                    loop: 1,
                    mute: 1,
                    controls: 0,
                    modestbranding: 0,
                    rel: 0,
                },
                events: {
                    onReady: window.onPlayerReady,
                    onStateChange: window.onPlayerStateChange,
                },
            });
        };
        window.onPlayerReady = function (event) {
            event.target.playVideo();
        };
        window.onPlayerStateChange = function (event) {
            if (event.data === YT.PlayerState.ENDED) {
                player.playVideo();
                // const YTP = event.target;
                // if (event.data === 1) {
                //     // console.log(YTP.getDuration());
                //     // console.log(YTP.getCurrentTime());
                //     // const remains =
                //     //     YTP.getDuration() - YTP.getCurrentTime();
                //     // console.log(remains);
                //     // if (window.rewindTO) clearTimeout(window.rewindTO);
                //     // window.rewindTO = setTimeout(function () {
                //     //     YTP.seekTo(0);
                //     // }, (remains - 0.1) * 1000);
                // }
            }
        };
    }
    /**
     *
     * @param {node selector} videoBannerSelector example {div.video-banner--js.main-banner__background-video}
     * @param {string} videoId example 23452432
     * @param {obj} videoSice {width, height}
     */
    function appendVimeoBanner(videoBannerSelector, videoId, videoSice) {
        const vimeoVideo = `
        <iframe class="lightbox__iframe" width=${videoSice.width} height=${videoSice.height}
            src="https://player.vimeo.com/video/${videoId}?muted=1&autoplay=1&loop=1&controls=0"
            frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen
        >
        </iframe>`;
        videoBannerSelector.innerHTML = vimeoVideo;
    }
};

const videoBannerSelector = document.querySelector(".video-banner--js");
//obj with name and value
if (videoBannerSelector) {
    const dataAttr = [...videoBannerSelector.attributes].filter((el) =>
        el.name.includes("data-video-id")
    )[0];
    appendVideoBanner(videoBannerSelector, dataAttr.value);
}
